import http from "./http"
// post 
export const post = <T = any>(url: string, params?: any) => http.post<T, T>(url, params)
export const put = <T = any>(url: string, params?: any) => http.put<T, T>(url, params)
export const get = <T = any>(url: string, params?: any) => http.get<T, T>(url, params)
export const del = <T = any>(url: string, params?: any) => http.delete<T, T>(url, params)